module.exports = __webpack_public_path__ + "img/consult.88a49600.jpg";